module.exports = __webpack_public_path__ + "static/media/actavo.9bd8947b.png";